"use strict";

exports.__esModule = true;
exports.parseServerState = exports.hasSessionExpired = exports.encodeState = exports.decodeState = exports.calculateExpiration = void 0;
var encodeState = exports.encodeState = function encodeState(input) {
  return btoa(JSON.stringify(input));
};
var decodeState = exports.decodeState = function decodeState(input) {
  return JSON.parse(atob(input));
};
var parseServerState = exports.parseServerState = function parseServerState(input) {
  return {
    accessToken: input.access_token || null,
    appState: null,
    expiresAt: parseInt(input.expires_at, 10) * 1000 || null,
    expiresIn: null,
    idToken: input.id_token || null,
    idTokenPayload: input.payload || null,
    refreshToken: input.refresh_token || null,
    scope: null,
    state: input.state || null,
    tokenType: input.access_token ? 'Bearer' : null,
    provider: input.provider || null
  };
};
var calculateExpiration = exports.calculateExpiration = function calculateExpiration(result) {
  var now = Date.now();
  return result.expiresIn != null ? now + result.expiresIn * 1000 : null;
};
var hasSessionExpired = exports.hasSessionExpired = function hasSessionExpired(session) {
  var now = Date.now();
  return session.expiresAt != null && now > session.expiresAt;
};